import { DtoMapper } from '@wemogy/reactbase';
import {IForm} from '../../models/Form';

export default class FormDtoMapper extends DtoMapper<IForm, any>{

}
